"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanUpFileContent = void 0;
const common_1 = require("@finley-technologies/common");
// This function determines if a character is not a printable character or a control character
const isGoodCharacter = (code) => {
    const TAB = 0x09;
    const LF = 0x0a;
    const CR = 0x0d;
    const SPACE = 0x20;
    const DEL = 0x7f;
    const isGoodUTF8Character = code === TAB ||
        code === LF ||
        code === CR ||
        (code >= SPACE && code !== DEL);
    return isGoodUTF8Character;
};
/**
 *
 * This cleans up input buffer content by removing non-printable characters and control characters
 */
const cleanUpFileContent = (buffer, startOffset) => {
    const content = common_1.finleyBuffer.toString(buffer);
    if (startOffset >= content.length || startOffset < -content.length) {
        throw new Error(`Invalid start offset [${startOffset}]: startOffset must be within content length bounds [-${content.length}, ${content.length}]`);
    }
    // Calculate the start index based on the start offset
    // If the start offset is negative, it is the number of characters from the end of the file
    const startIndex = Math.max(0, startOffset < 0 ? content.length + startOffset : startOffset);
    // since bad characters are usually in clusters, we can optimize the removal process
    // by identifying the ranges of bad characters and removing them in one go
    const removalRanges = []; // Store ranges as tuples [start, end]
    let inRemovalRange = false;
    let rangeStart = -1;
    // eslint-disable-next-line no-restricted-syntax, finley/variable-length, no-plusplus
    for (let i = startIndex; i < content.length; i++) {
        const code = content.charCodeAt(i);
        const isRemovable = !isGoodCharacter(code);
        if (isRemovable && !inRemovalRange) {
            // Start of a new removal range
            rangeStart = i;
            inRemovalRange = true;
        }
        else if (!isRemovable && inRemovalRange) {
            // End of current removal range
            removalRanges.push([rangeStart, i - 1]);
            inRemovalRange = false;
        }
    }
    // Check if the last characters are in a removal range
    if (inRemovalRange) {
        removalRanges.push([rangeStart, content.length - 1]);
    }
    // Construct the cleaned content by skipping the removal ranges
    let result = content.substring(0, startIndex);
    let lastEndIndex = startIndex - 1;
    removalRanges.forEach(([start, end]) => {
        result += content.substring(lastEndIndex + 1, start);
        lastEndIndex = end;
    });
    if (lastEndIndex < content.length - 1) {
        result += content.substring(lastEndIndex + 1);
    }
    if (result.length !== content.length) {
        return common_1.finleyBuffer.fromString(result);
    }
    return buffer;
};
exports.cleanUpFileContent = cleanUpFileContent;
//# sourceMappingURL=cleanupUtf8.js.map